import { useEffect, useState } from "react";
import { AddSuppliersToOrganizationData, addSupplierToOrganization, getOrganizationSuppliers, getSupplier, getSuppliers, SupplierData } from "../remote/suppliers";
import { Button, Form, H3, H4, Input, Label, ListItem, Spinner, XStack, YStack } from "tamagui";
import { CheckboxWithLabel } from "./CheckboxWithLabel";
import { Check, PlusCircle } from "@tamagui/lucide-icons";
import { Header } from "./Header";
import { useNavigate } from "react-router-dom";

class SupplierAddProps {
	orgId?: string;

	constructor(orgId?: string, createNew?: boolean) {
		this.orgId = orgId;
	}
}

const setupFormProperty = (def: any) => {
	const [prop, setter] = useState(def)
	return [prop, setter, (event) => {
		setter(event.target.value)
	}]
}

export const SupplierAdd = (props: SupplierAddProps) => {
	const [organizationSuppliers, setOrganizationSuppliers] = useState<SupplierData[] | null>(null);
	const [areOrganizationSuppliersLoaded, setOrganizationSuppliersLoaded] = useState(false)

	const navigate = useNavigate()

	if (props.orgId) {
		useEffect(() => {
			if (props.orgId) {
				getOrganizationSuppliers(props.orgId, (data, resp) => {
					if (data) {
						setOrganizationSuppliers(data);
						setOrganizationSuppliersLoaded(true);
					} else {
						setOrganizationSuppliers(null);
						setOrganizationSuppliersLoaded(false);
					}
				});
			} else {
				setOrganizationSuppliers(null);
				setOrganizationSuppliersLoaded(false);
			}
		}, [setOrganizationSuppliers, setOrganizationSuppliersLoaded]);
	}

	const [allSuppliers, setAllSuppliers] = useState<SupplierData[] | null>(null);
	const [areAllSuppliersLoaded, setAreAllSuppliersLoaded] = useState(false)

	if (props.orgId) {
		useEffect(() => {
			if (props.orgId) {
				getSuppliers((data, resp) => {
					if (data) {
						setAllSuppliers(data);
						setAreAllSuppliersLoaded(true);
					} else {
						setAllSuppliers(null);
						setAreAllSuppliersLoaded(false);
					}
				});
			} else {
				setAllSuppliers(null);
				setAreAllSuppliersLoaded(false);
			}
		}, [setAllSuppliers, setAreAllSuppliersLoaded]);
	}

	const [addableSuppliers, setAddableSuppliers] = useState<SupplierData[]>([]);
	useEffect(() => {
		if (areAllSuppliersLoaded && areOrganizationSuppliersLoaded) {
			setAddableSuppliers(allSuppliers?.filter((x) => {
				let result = organizationSuppliers?.find((y) => {return y.id == x.id});
				return result ? false : true;
			}) ?? []);
		}
	}, [areAllSuppliersLoaded, areOrganizationSuppliersLoaded, setAddableSuppliers])

	const addSupplier = (id: string) => {
		if (props.orgId) {
			let data = new AddSuppliersToOrganizationData([id])
			addSupplierToOrganization(props.orgId, data, () => {
				navigate(-1)
			})
		}
	}

	return <>
		<Header></Header>
		<YStack minWidth={600} flex={1} justify="flex-start" margin='$8' borderRadius="$4" backgroundColor="$background" borderColor="$borderColor">
			<H3>Add supplier to organization</H3>
			{areOrganizationSuppliersLoaded && areAllSuppliersLoaded
			? <> {
				addableSuppliers.map((x) => {
					return <ListItem title={x.name}>
						<Button icon={PlusCircle} onPress={(e) => addSupplier(x.id)}>Add supplier to org</Button>
					</ListItem>
				})
			}</>
			: <Spinner />}
		</YStack>
	</>
}
